var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#EBF0F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9999 9.95964C13.1623 9.95964 12.4833 10.6387 12.4833 11.4763C12.4833 12.3139 13.1623 12.993 13.9999 12.993C14.8376 12.993 15.5166 12.3139 15.5166 11.4763C15.5166 10.6387 14.8376 9.95964 13.9999 9.95964ZM11.3166 11.4763C11.3166 9.99434 12.518 8.79297 13.9999 8.79297C15.4819 8.79297 16.6833 9.99434 16.6833 11.4763C16.6833 12.9583 15.4819 14.1596 13.9999 14.1596C12.518 14.1596 11.3166 12.9583 11.3166 11.4763ZM8.38829 17.8264C9.3062 16.2953 11.2416 15.3707 13.9999 15.3707C16.7583 15.3707 18.6937 16.2953 19.6116 17.8264C19.7772 18.1027 19.6875 18.461 19.4112 18.6266C19.1349 18.7923 18.7766 18.7026 18.6109 18.4263C17.9825 17.3781 16.5289 16.5374 13.9999 16.5374C11.4709 16.5374 10.0173 17.3781 9.38891 18.4263C9.22325 18.7026 8.86496 18.7923 8.58865 18.6266C8.31234 18.461 8.22263 18.1027 8.38829 17.8264Z",
    fill: "#B6BFCB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/Avatar.cb57bbd7c12a68a6bc88813d403ffe9a.svg";
export { ForwardRef as ReactComponent };